// extracted by mini-css-extract-plugin
module.exports = {"productsList":"styles_productsList__gjavf","title":"styles_title__2cvXH","launchDate":"styles_launchDate__VltK_","description":"styles_description__6o9OR"};